import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";
import { Formik, Form, Field } from "formik";

import * as Yup from "yup";
import * as Schemas from "../forms/validationSchemas.js";

import FormikSemanticInput from "../forms/formik/FormikSemanticInput.jsx";
import FormikSemanticDropdown from "../forms/formik/FormikSemanticDropdown.jsx";
import FormikActionsPanel from "../forms/formik/FormikActionsPanel.jsx";

import {
  selectProjectRoleOptions,
  selectSudoRoleOptions
} from "../../state/reducers/resources/resourceSelector.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class AddUserToResourceForm extends PureComponent {
  static propTypes = {
    entity: PropTypes.object,
    disabled: PropTypes.bool,
    onFormikSubmit: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onInviteByExistingUser: PropTypes.func,
    renderMessage: PropTypes.func.isRequired,
    violationErrors: PropTypes.object,

    projectRoleOptions: PropTypes.array,
    sudoRoleOptions: PropTypes.array,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "users.user_panel",
    disabled: false
  };

  constructor(props) {
    super(props);

    this.initialValues = {
      email: "",
      projectGroup: null,
      sudo: ""
    };
  }

  // -- VALIDATION -- //

  validationSchema = () => {
    const messages = this.props.copy("forms.validation_requirements");

    return Yup.object().shape({
      email: Schemas.emailSchema("Email", messages, true),
      projectGroup: Yup.mixed(), // will be required once implemented on the api side
      sudo: Schemas.dropdownSchema("Access Level", messages, true)
    });
  };

  // -- RENDER -- //

  render() {
    const {
      entity,
      projectRoleOptions,
      sudoRoleOptions,
      onReset,
      onCancel,
      onInviteByExistingUser,
      onFormikSubmit,
      renderMessage,
      disabled,
      violationErrors,
      copyKey,
      copy
    } = this.props;

    // temp until api update
    const canAddUsers = true;

    // bail early if base permissions are not met
    if (!canAddUsers) {
      return null;
    }

    const showGroups = projectRoleOptions && projectRoleOptions.length > 0;

    return (
      <Formik
        initialValues={this.initialValues} // required by semantic-ui react
        validateOnMount={true}
        validationSchema={this.validationSchema()}
        onSubmit={onFormikSubmit}
      >
        {formikProps => {
          return (
            <Fragment>
              <Header as="h3">
                {copy(`${copyKey}.add_user_by_email.title`)}
              </Header>
              <Segment secondary>
                <p>{copy(`${copyKey}.add_user_by_email.description`)}</p>
                {renderMessage(formikProps)}
                <Form className="ui form">
                  <Field
                    name="email"
                    placeholder={copy(`${copyKey}.email_placeholder`)}
                    label={copy(`${copyKey}.email_label`)}
                    required
                    disabled={disabled}
                    apiErrors={violationErrors}
                    component={FormikSemanticInput}
                  />
                  <div className="equal width fields">
                    {showGroups && (
                      <Field
                        name="projectGroup"
                        placeholder={copy(`${copyKey}.group_placeholder`)}
                        label={copy(`${copyKey}.group_label`)}
                        options={projectRoleOptions}
                        required
                        selection
                        disabled={disabled}
                        apiErrors={violationErrors}
                        component={FormikSemanticDropdown}
                      />
                    )}
                    <Field
                      name="sudo"
                      placeholder={copy(`${copyKey}.sudo_placeholder`)}
                      label={copy(`${copyKey}.sudo_label`)}
                      options={sudoRoleOptions}
                      required
                      selection
                      disabled={disabled}
                      apiErrors={violationErrors}
                      component={FormikSemanticDropdown}
                    />
                  </div>
                  {onInviteByExistingUser && (
                    <p>
                      {copy(`${copyKey}.add_by_or`)}{" "}
                      <a
                        onClick={onInviteByExistingUser}
                        className="show-pointer"
                      >
                        {copy(`${copyKey}.add_user_by_existing.link`)}
                      </a>
                    </p>
                  )}
                  <FormikActionsPanel
                    onCancel={onCancel}
                    reset={true}
                    onReset={onReset}
                    submit={true}
                    useSubmitModal={true}
                    modalCopy={copy(`${copyKey}.modals`)}
                    panelCopy={copy(`${copyKey}.actions_panel`)}
                    entity={entity}
                  />
                </Form>
              </Segment>
            </Fragment>
          );
        }}
      </Formik>
    );
  }
}

const mapStateToProps = (state, props) => ({
  projectRoleOptions: selectProjectRoleOptions(state, props),
  sudoRoleOptions: selectSudoRoleOptions(state, props),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(AddUserToResourceForm);
